import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UserDetailRoutingModule } from './user-detail-routing.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UserDetailRoutingModule,
  ]
})
export class UserDetailModule { }
